import React from 'react';
import { Box } from "@mui/material";
import ScienceIcon from '@mui/icons-material/Science';
import { isSandbox } from '../../../utils/environment';

export const BAR_HEIGHT = 32;

/** Faixa fixa no rodapé da tela indicando que o portal aponta para o ambiente de sandbox. */
export default function SandboxBar() {
  if (!isSandbox()) return null;

  return (
    <>
      {/* Reserva o espaço da faixa para não cobrir o fim da página */}
      <Box sx={{ height: BAR_HEIGHT }} />
      <Box
        role="status"
        sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2000,
          height: BAR_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          px: 2,
          backgroundColor: '#ed6c02',
          color: '#fff',
          fontSize: '0.8125rem',
          fontWeight: 700,
          letterSpacing: '.02em',
          boxShadow: '0 -2px 6px rgba(0,0,0,.15)',
        }}
      >
        <ScienceIcon sx={{ fontSize: 18 }} />
        AMBIENTE DE SANDBOX — dados de teste, não é o portal oficial
      </Box>
    </>
  );
}
